import { createContext, FC, ReactNode, useContext, useMemo } from 'react';

import { Cache, CacheStore, globalCache } from './Cache';

const CacheContext = createContext<Cache>(globalCache);

interface CacheProviderProps {
	children: ReactNode;
	store?: CacheStore;
}

export const useCache = (): Cache => useContext(CacheContext);

export const IDQACacheProvider: FC<CacheProviderProps> = ({ children, store }) => {
	// eslint-disable-next-line
	useMemo(() => {
		if (store) {
			globalCache.configure(store);
		}
	}, [store]);

	return <CacheContext.Provider value={globalCache}>{children}</CacheContext.Provider>;
};
